/*eslint-disable no-undef */
import $ from 'jquery';
import utils from './utils';
import conf from './conf';
import store from './store';
import loginUtils from './login';
import query from './query';
import logger from './logger';
import reportUtil from 'common/js/report';

/**
 * 微信支付工具类
 */
class PayWx {
    constructor() {
        // 后台识别支付来源标识
        this.PAY_APPID = 1021;

        this.wxSignInfo = null;
        this.paySignInfo = null;
        this.openId = loginUtils.user.openid;
    }

    /**
     * JSONP共用方法
     * @param options {Object} 请求配置
     * @returns
     */
    jsonp(options) {
        return $.ajax(Object.assign({
            url: conf.dataUrls.pay,
            dataType: 'jsonp'
        }, options));
    }

    /**
     * 获取支付加密信息
     * @param callback 回调函数
     */
    getTimeSign(params) {
        let self = this;
        this.jsonp({
            data: {
                do: 'getTimeSign',
                openId: this.openId,
                appId: this.PAY_APPID
            }
        }).done(function(res) {
            if(res.status === 200) {
                self.paySignInfo = res.data;
                params.success && params.success(res.data);

	            // 上报订单号
	            reportUtil.report({
		            eid: "recharge/orderid",
		            eid_desc: "充值/订单号",
		            extra: JSON.stringify([{"orderid": res.data.orderId, ayyuid: (conf.cRoomInfo && conf.cRoomInfo.yyid) || "" }])
	            });
            }else{
                params.fail && params.fail({
                    errMsg: "getTimeSign:fail",
                    txt: res.msg
                });
            }
        });
    }

    /**
     * 提交订单并唤起微信支付
     * @param params {Object}
     * {
     *    num:  金豆数量
     *    total： 支付金额
     *    callback: 支付成功回调
     * }
     */
    doPayMoney(params) {
        let paySignInfo = this.paySignInfo;
        let self = this;

        this.jsonp({
            data: {
                do: 'doPayMoney',
                appId: this.PAY_APPID,   // 来源区分，联运项目固定用这个
                beanNum: params.beanNum,
                payTotal: params.total,
                buyWay: params.buyWay,
                uid: paySignInfo.uid,
                openId: paySignInfo.openId,
                channelId: query.value.promoter || query.value.channel,
                time: paySignInfo.time,
                sign: paySignInfo.sign,
                orderId: paySignInfo.orderId
            }
        }).done(function(res) {
            if(res.status === 200 && res.data !== null) {
                let oInfo = res.data.payUrl
                oInfo = JSON.parse(decodeURIComponent(oInfo));
                Object.assign(oInfo, {callback: params.callback});
                self.evokeWXPay(oInfo)
            }else{
                params.callback && params.callback({
                    errMsg: "doPayMoney:fail",
                    txt: '订单创建失败'
                });
            }
        });
    }


    /**
     * 唤起微信支付
     * @param callback {Function} 支付回调方法
     */
    evokeWXPay(params) {
	    let paySignInfo = this.paySignInfo;

        logger.log('evokeWXPay', params);
        wx.chooseWXPay({
            timestamp: params.timeStamp,
            nonceStr: params.nonceStr,
            package:  params.package,
            signType: "MD5",
            paySign: params.paySign,
            success: function(res) {
                //alert('success' + JSON.stringify(res));
                params.callback && params.callback({
                    errMsg: res.errMsg,
                    txt: 'V币充值成功'
                });
            },
            cancel: function(res) {
                //alert('cancel' + JSON.stringify(res));
                params.callback && params.callback({
                    errMsg: res.errMsg,
                    txt: '支付已取消'
                });
            },
            fail: function(res) {
                //alert('fail' + JSON.stringify(res));
                params.callback && params.callback({
                    errMsg: res.errMsg,
                    txt: '充值失败，请重试'
                });
            }
        });
    }

    /**
     * 立即支付
     * @param params {Object} 支付配置
     */
    submitPay(params) {
        let self = this;

        this.getTimeSign({
            success: function() {
                self.doPayMoney(params);
            },
            fail: params.callback
        });
    }
}


/**
 *  浏览器支付工具类
 */
class PayUniversal {
	constructor() {
		this.failCount = 0;
		this.appId = utils.isWx ? 1030 : 1029;
		this.payUrl = conf.dataUrls.payUn;
		this.payInfo = null;

		this.getPayInfo();
	}

    /**
     * 获取用户账户信息
     */
    getUserInfo(callback) {
        return $.ajax({
            dataType: 'jsonp',
            url: this.payUrl,
            data: {
                do: 'getUserInfo',
                yyUid:  loginUtils.user.uid || store.cookie.get("yyuid") || store.cookie.get("udb_uid"),
                appId: this.appId
            }
        }).done(function(res) {
            if(+res.status === 200) {
                callback && callback(res.data);
            }

        });
    }

	/**
	 * 获取加密信息
	 * @param callback 回调方法
	 */
	getTimeSign(param, callback) {
		let self = this;

		$.ajax({
			url: this.payUrl,
			dataType: 'jsonp',
			data: {
				do: 'getTimeSign'
			}
		}).done(function(res) {
			if(res.status === 200) {

				// 上报订单号
				reportUtil.report({
					eid: "recharge/orderid",
					eid_desc: "充值/订单号",
					extra: JSON.stringify([{"orderid": res.data.orderId}])
				});

				param.data = Object.assign(param.data, res.data);
				self.doPayMoney(param);
			}else{
				logger.error("加密信息获取失败");
				if(self.failCount < 3) {
					self.failCount++;
					self.getTimeSign(param);
					callback && callback();
				}
			}
		}).fail(function() {
			logger.error("加密信息获取失败");
			if(self.failCount < 3) {
				self.failCount++;
				self.getTimeSign(param);
			}

			callback && callback();
		});
	}

	/**
	 * 获取支付渠道与套餐
	 */
	getPayInfo(callback) {
		var self = this;

		if(!this.payInfo){
			$.ajax({
				url: this.payUrl,
				dataType: 'jsonp',
				data: {
					do: 'getPayInfo',
					appId: self.appId
				}
			}).done(function(res) {
				if(res.status === 200) {
					self.payInfo = res.data;
					callback && callback({
						payPackage: res.data.payPackage,
						payType: res.data.payType
					});
				}
			});
		}else{
			callback && callback({
				payPackage: this.payInfo.payPackage,
				payType: this.payInfo.payType
			});
		}

	}
	/**
	 * 立即支付
	 */
	doPayMoney(param) {
		var self = this;

		$.ajax({
			url: this.payUrl,
			dataType: 'jsonp',
			data: Object.assign({
				do: 'doPayMoney',
				appId: self.appId
			}, param.data)
		}).done(function(res) {
			param.callback(res);
		});
	}

    /**
     * 唤起微信支付
     * @param callback {Function} 支付回调方法
     */
    evokeWXPay(params) {
        logger.log('evokeWXPay', params);
        wx.chooseWXPay({
            timestamp: params.timeStamp,
            nonceStr: params.nonceStr,
            package:  params.package,
            signType: "MD5",
            paySign: params.paySign,
            success: function(res) {
                //alert('success' + JSON.stringify(res));
                params.callback && params.callback(res);
            },
            cancel: function(res) {
                //alert('cancel' + JSON.stringify(res));
                params.callback && params.callback(res);
            },
            fail: function(res) {
                //alert('fail' + JSON.stringify(res));
                params.callback && params.callback(res);
            }
        });
    }
}

const payUn = new PayUniversal();

export {payUn};


// WEBPACK FOOTER //
// ./src/common/js/pay.js